import React, { useEffect, useReducer } from "react";
import { withHeaderMessages } from "../higherOrderComponents/WithHeaderMessages";
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { Row, Col, Container, Alert } from "react-bootstrap";
import { LoadingSpinner } from "../lib/components/LoadingSpinner";

const Forms = (props) => {
  const initialState = {
    forms: [],
    error: "",
    isLoading: true
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "forms":
        return {
          ...state,
          forms: action.payload,
          isLoading: false,
        };
      case "error":
        return {
          ...state,
          error: action.payload,
        };
      case "isLoading":
        return {
          ...state,
          isLoading: action.payload,
        };
      case "hideLoader":
        return {
          ...state,
          isLoading: false,
        };
      default:
        throw new Error();
    }
  };

  const [formsState, dispatch] = useReducer(reducer, initialState);
  const downloadFile = async (referenceId, event) => {
    dispatch({ type: "error", payload: "" });
    await props.api
      .getBlob(`/api/form/${referenceId}`)
      .then((response) => {
        if (response.status === 200) {
          var filename = "";
          var disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          return {
            filename: filename,
            blob: new Blob([response.data], { type: response.data.type }),
          };
        }
      })
      .then((file) => {
        let blobUrl = window.URL.createObjectURL(file.blob);

        let anchor = document.createElement("a");
        anchor.href = blobUrl;
        anchor.download = file.filename;
        document.body.appendChild(anchor);
        anchor.click();
        setTimeout(function () {
          document.body.removeChild(anchor);
          window.URL.revokeObjectURL(blobUrl);
        }, 100);
      })
      .catch((error) => {
        dispatch({
          type: "error",
          payload:
            "Error retrieving form. Please try again later or contact support if the problem persists.",
        });
      });
  };

  const hideLoader = () => {
    dispatch({ type: "isLoading", payload: false });
  };

  useEffect(() => {
    async function getForms() {
      props.header.setHeader("formsLibrary");
      await props.api
        .get(`/api/form/list`)
        .then((response) => {
          if (response.status === 200) {
            return response.data;
          }
        })
        .then((data) => {
          dispatch({ type: "forms", payload: data });
        })
        .catch(hideLoader)
        .then(hideLoader);
    }
    getForms();
  }, []);

  const { forms, error } = formsState;

  const distinctFormTypes = () => {
    const { forms } = formsState;
    var flags = [],
      output = [],
      l = forms.length,
      i;
    for (i = 0; i < l; i++) {
      if (flags[forms[i].formTypeId]) continue;
      flags[forms[i].formTypeId] = true;
      output.push(forms[i]);
    }
    
    return output;
  };

  const handleAlertClose = () => {
    dispatch({ type: "Error", payload: "" });
  }

  const { isLoading } = formsState;

  return (
    <Container>
      {(isLoading) ? (
        <LoadingSpinner />
      ) : (
        <div>
          {error !== "" && (
            <Alert variant="danger" role="alert" dismissible onClose={handleAlertClose}>
              {error}
            </Alert>
            
          )}
          {distinctFormTypes().map((ft) => {
            return (
              <Container key={ft}>
                  <Row>
                    <Col style={{height: '70px'}} className={`${ft.formType.name.replace(/\W/g, '')}`}> </Col>
                    <Col className="formType col-11 pt-1">{ft.formType.name.toUpperCase()}</Col>
                    <Col style={{marginTop: '-30px'}}>
                {forms
                  .filter((r) => r.formTypeId === ft.formTypeId)
                  .map((r) => {
                    return (
                        <div sm={12} className="fileNames">
                          <span className='fileName'>{r.fileName}</span>
                          <button
                            className="mx-3 download-link"
                            onClick={(event) => downloadFile(r.referenceId, event)}
                          >
                            Download
                          </button>
                        </div>
                    );
                  })}
                  </Col>
                  </Row>
              </Container>
            );
          })}
        </div>
      )}
    </Container>
  );
};

export default withHeaderMessages(WithApiAccess(Forms));
